import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import Media from 'react-media';
import ReactPlayer from 'react-player';

// This modal component does not work the same as the way the FullScreenModal works.
// See QuickAddDropdownButton.js to see how to implement this react-modal based component.

export default class CreateNewTasksModal extends Component {
  static propTypes = {
    contentLabel: PropTypes.string,
    showModal: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    cb: PropTypes.func,
  };

  render() {
    const {
      showModal,
      contentLabel,
      handleCloseModal,
      // content,
      link,
    } = this.props;

    return (
      <Media query="(max-width: 992px)">
        {matches => (
          <ReactModal
            isOpen={showModal}
            contentLabel={contentLabel}
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                overflowY: 'auto',
              },
              content: {
                marginLeft: 'auto',
                marginRight: 'auto',
                padding: 0,
                border: 'none',
                bottom: 'auto',
                borderRadius: 4,
                maxWidth: matches ? '90vw' : '60vw',
              },
            }}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#eee' }}>
                <h5 className="modal-title">{link && link.title}</h5>
                <button
                  onClick={handleCloseModal}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i
                    className="fa fa fa-times"
                    style={{ fontSize: '1.3em', color: '#808080' }}
                  />
                </button>
              </div>
              <div
                className="modal-body"
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <ReactPlayer url={link && link.url} playing />
              </div>
              <div
                className="modal-footer"
                style={{ backgroundColor: '#eee', padding: 0 }}
              >
                {/* <button
                  className="btn btn-primary modal-submit-btn"
                  data-test="createButton"
                >
                  Stuff
                </button> */}
              </div>
            </div>
          </ReactModal>
        )}
      </Media>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/GetStartedModal.js